(function () {
  const INPUT_SEL = '[data-hb-ai-search-input]';
  const BAR_SEL = '[data-hb-ai-bar]';
  const BAR_TEXT_SEL = '[data-hb-ai-bar-text]';
  const SUG_SEL = '[data-hb-ai-suggestion]';

  /** Mirrors `intentMap` from the reference BoldZee shop demo — drives messaging + scoring. */
  const INTENT_MAP = [
    {
      k: ['slow', 'speed', 'loading', 'performance', 'mobile', 'phone', 'broken', 'experience'],
      msg: 'For website experience issues, here are your best options.',
    },
    {
      k: ['seo', 'rank', 'google', 'traffic', 'organic', 'search', 'visibility', 'keywords'],
      msg: 'For search visibility and rankings, start here.',
    },
    {
      k: ['convert', 'conversion', 'cro', 'bounce', 'landing', 'sales', 'buy', 'visitors'],
      msg: "For conversion problems, these services will find what's stopping sales.",
    },
    {
      k: ['google ads', 'ppc', 'ads', 'advertising', 'roas', 'campaign', 'paid'],
      msg: "For paid advertising, here's where to start.",
    },
    {
      k: ['shopify', 'ecommerce', 'store', 'product', 'cart', 'launch', 'setup'],
      msg: 'For Shopify growth, these services are built for exactly that.',
    },
    {
      k: ['analytics', 'tracking', 'ga4', 'pixel', 'tag manager', 'data', 'gtm'],
      msg: "For tracking and analytics, here's the right setup.",
    },
    {
      k: ['design', 'redesign', 'figma', 'brand', 'build', 'look', 'page'],
      msg: 'For design work, here are your options.',
    },
    {
      k: ['local', 'near', 'maps', 'google business', 'location'],
      msg: 'For local search dominance, start with these.',
    },
  ];

  const TYPEWRITER_PHRASES = [
    "My website isn't converting visitors…",
    'I want to rank higher on Google…',
    'My ads are spending but not converting…',
    "I don't know what's wrong with my site…",
    'My mobile experience feels broken…',
    "My Shopify store isn't making enough sales…",
  ];

  let twPi = 0;
  let twCi = 0;
  let twDel = false;
  let twTimer = null;

  /** Last AI prompt while results are showing. */
  let lastAiQuery = '';

    /**
   * Handles from the original AI run on the full collection. Tag/sale/sort refreshes intersect this
   * set with products on the page instead of re-scoring (which picked unrelated items).
   * @type {Set<string>|null}
   */
  let persistentAiHandles = null;

  /** Score for each handle in `persistentAiHandles`, carried through tag/sale/sort refreshes. */
  let persistentAiScores = new Map();

  /** True when the last AI run found no real match and fell back to showing everything. */
  let persistentNoMatch = false;

  /** Intent message shown in the AI bar for the active session. */
  let lastAiBarMsg = '';

  function getBannerInput() {
    return document.querySelector(INPUT_SEL);
  }

  function getAiBar() {
    return document.querySelector(BAR_SEL);
  }
  
  
  /** Dims the All tab's active look while an AI search is narrowing the grid,
   * so it never appears selected when only a subset is showing. */
   function setAllTabAiState(isActive) {
    const root = document.querySelector('[data-collection-filter-root]');
    if (root) root.classList.toggle('hb-ai-search-active', !!isActive);
  }

  /** Whole-word match (not substring), so "cart" never matches inside "cartoon".
   * `term` may be a multi-word phrase ("google ads") — \b anchors its outer edges. */
  function containsTerm(haystack, term) {
    if (!term) return false;
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`\\b${escaped}\\b`, 'i').test(haystack);
  }





  /** Bring the AI message bar + matched services up under the sticky header. */
  function scrollToGrid() {
    const bar = getAiBar();
    const target = bar && !bar.hidden ? bar : document.querySelector('.cus-collection__wrapper');
    if (!target) return;
    if (window.BzScroll) {
      window.BzScroll.to(target);
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function cardAiTitle(card) {
    const fromAttr = card.getAttribute('data-hb-ai-search-title');
    if (fromAttr != null && fromAttr !== '') return fromAttr.toLowerCase();
    return (card.querySelector('.cus-collection__product-title')?.textContent ?? '').toLowerCase();
  }

  /** Full searchable corpus: prefers Liquid-built attribute (full description, all tags, vendor, type, metafields, SKU). */
  function cardSearchBlob(card) {
    const fromAttr = card.getAttribute('data-hb-ai-search-text');
    if (fromAttr != null && fromAttr !== '') return fromAttr.toLowerCase();
    const title = card.querySelector('.cus-collection__product-title')?.textContent ?? '';
    const desc = card.querySelector('.cus-collection__product-desc')?.textContent ?? '';
    const tags = [...card.querySelectorAll('.cus-collection__product-tags')]
      .map((el) => el.textContent ?? '')
      .join(' ');
    return `${title} ${desc} ${tags}`.toLowerCase();
  }

  /**
   * Score products from the current grid against the visitor prompt (client-side “AI”).
   * @returns {{ handles: Set<string>, msg: string }}
   */
  function matchProductsToQuery(query, wrapper) {
    const lower = query.toLowerCase();
    const grid = wrapper.querySelector('.cus-collection__grid');
    const cards = grid ? [...grid.querySelectorAll('.cus-collection__card')] : [];

       let intentHit = null;
    for (const intent of INTENT_MAP) {
      if (intent.k.some((k) => containsTerm(lower, k))) {
        intentHit = intent;
        break;
      }
    }

    const words = lower.split(/[^\p{L}\p{N}]+/u).filter((w) => w.length > 2);

    const scores = [];
    cards.forEach((card) => {
      const handle = card.dataset.productHandle ?? '';
      if (!handle) return;

      const blob = cardSearchBlob(card);
      const titleBlob = cardAiTitle(card);
      let score = 0;

      if (intentHit) {
        intentHit.k.forEach((k) => {
          if (containsTerm(lower, k) && containsTerm(blob, k)) score += 18;
          else if (containsTerm(blob, k)) score += 6;
        });
      }

      words.forEach((w) => {
        if (containsTerm(titleBlob, w)) score += 7;
        else if (containsTerm(blob, w)) score += 4;
      });

      scores.push({ handle, score, blob });
    });

        scores.sort((a, b) => b.score - a.score);
    const maxScore = scores[0]?.score ?? 0;

    let picks = scores.filter((s) => s.score > 0 && (!maxScore || s.score >= Math.max(4, maxScore * 0.35)));

    if (!picks.length && scores.some((s) => s.score > 0)) {
      picks = scores.filter((s) => s.score > 0).slice(0, 8);
    }

    const noMatch = picks.length === 0;

    let msg = '';
    if (noMatch) {
      msg = "We couldn't find an exact match for that — here's our full lineup.";
    } else if (intentHit) {
      msg = intentHit.msg;
    } else {
      msg = 'Here are the most relevant services.';
    }

    const handles = new Set();
    const productScores = new Map();
    if (noMatch) {
      // Honest fallback: show everything, but the caller marks this as a
      // non-match (no highlight ring, muted bar) instead of pretending
      // every product scored a hit.
      cards.forEach((card) => {
        const h = card.dataset.productHandle;
        if (h) handles.add(h);
      });
    } else {
      picks.forEach((p) => {
        handles.add(p.handle);
        productScores.set(p.handle, p.score);
      });
    }

    return { handles, msg, scores: productScores, noMatch };
  }

  function applyAiQuery(rawQuery, opts) {
    const q = rawQuery.trim();
    if (!q) return;

    const api = window.HbCollectionFilter;
    if (!api?.setAiMatches) return;

    const wrapper = document.querySelector('.cus-collection__wrapper');
    if (!wrapper) return;

       lastAiQuery = q;

    const { handles, msg, scores, noMatch } = matchProductsToQuery(q, wrapper);

    persistentAiHandles = new Set(handles);
    persistentAiScores = scores;
    persistentNoMatch = noMatch;
    lastAiBarMsg = msg;

    // Feeds GTM (already installed sitewide) so real customer queries — especially
    // the zero/low-match ones — can be reviewed later and used to tune INTENT_MAP.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ai_search_performed',
      ai_search_query: q,
      ai_search_result_count: handles.size,
      ai_search_no_match: noMatch,
    });

    api.setAiMatches(handles, scores);
    api.sortAiMatchesFirst?.();
    api.recomputeCardVisibilityFromRoot?.();

    const bar = getAiBar();
    const barText = document.querySelector(BAR_TEXT_SEL);
    if (bar) {
      bar.hidden = false;
      bar.classList.toggle('hb-collection-ai-bar--fallback', !!noMatch);
    }
    if (barText) {
      const meta = noMatch ? `${handles.size} services shown.` : `${handles.size} matched services below.`;
      barText.innerHTML = `<strong>✦ ${msg}</strong> <span class="hb-ai-bar-meta">${meta}</span>`;
    }

    setAllTabAiState(true);

    if (opts?.scroll === true) scrollToGrid();

    document.dispatchEvent(new CustomEvent('hb-ai-search-applied', { bubbles: true }));
  }

    /** After tag/sale/sort AJAX: keep only products that were in the original AI result set. */
  function reapplyAiIntersection(opts) {
    const api = window.HbCollectionFilter;
    if (!api?.setAiMatches || persistentAiHandles === null) return;

    const wrapper = document.querySelector('.cus-collection__wrapper');
    if (!wrapper) return;

    const handlesOnPage = new Set(
      [...wrapper.querySelectorAll('.cus-collection__card')]
        .map((c) => c.dataset.productHandle)
        .filter(Boolean),
    );

    const intersected = new Set([...persistentAiHandles].filter((h) => handlesOnPage.has(h)));
    const intersectedScores = new Map(
      [...persistentAiScores].filter(([h]) => intersected.has(h)),
    );

    api.setAiMatches(intersected, intersectedScores);
    api.sortAiMatchesFirst?.();
    api.recomputeCardVisibilityFromRoot?.();

    const bar = getAiBar();
    const barText = document.querySelector(BAR_TEXT_SEL);
    if (bar) {
      bar.hidden = false;
      bar.classList.toggle('hb-collection-ai-bar--fallback', !!persistentNoMatch);
    }
    if (barText) {
      const n = intersected.size;
      const meta = persistentNoMatch ? `${n} services shown.` : `${n} matched services below.`;
      barText.innerHTML = `<strong>✦ ${lastAiBarMsg}</strong> <span class="hb-ai-bar-meta">${meta}</span>`;
    }

    setAllTabAiState(true);

    // if (opts?.scroll !== false) scrollToGrid();
  }





  function applyQuery(rawQuery) {
    const inp = getBannerInput();
    const v = (rawQuery ?? '').trim();
    if (!inp || !v) return false;
    inp.value = v;
    processBannerSearch();
    return true;
  }

  function processBannerSearch() {
    const inp = getBannerInput();
    const v = inp?.value?.trim() ?? '';
    if (!v) return;

    const root = document.querySelector('[data-collection-filter-root]');
    const allTab = root?.querySelector('[js-all]');
    if (!root || !allTab) {
      applyAiQuery(v, { scroll: true });
      return;
    }

    const saleActive = root.querySelector('[js-sale-tag].active');
    const tagActive = root.querySelector('[js-product-tags].active');

    if (!saleActive && !tagActive) {
      applyAiQuery(v, { scroll: true });
      return;
    }

    document.addEventListener(
      'hb-collection-dom-refreshed',
      () => {
        applyAiQuery(v, { scroll: true });
      },
      { once: true },
    );
    allTab.click();
  }

  function clearAiUi() {
    window.HbCollectionFilter?.clearAiSearch?.();
  }

    function wireSuggestion(el) {
    const q = el.getAttribute('data-hb-ai-suggestion') ?? el.textContent ?? '';

    // Rendered as a real <button> in Liquid now, so Enter/Space activation and
    // focus semantics come from the browser for free — only the click handler
    // is ours to wire.
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const inp = getBannerInput();
      if (!inp) return;
      inp.value = q.trim();
      processBannerSearch();
    });
  }

  function startTypewriter(inp) {
    function schedule(fn, ms) {
      if (twTimer) clearTimeout(twTimer);
      twTimer = setTimeout(fn, ms);
    }

    function tw() {
      if (document.activeElement === inp) {
        schedule(tw, 200);
        return;
      }

      const p = TYPEWRITER_PHRASES[twPi];
      if (twDel) {
        twCi -= 1;
        inp.placeholder = p.slice(0, Math.max(0, twCi));
        if (twCi <= 0) {
          twDel = false;
          twPi = (twPi + 1) % TYPEWRITER_PHRASES.length;
          schedule(tw, 380);
          return;
        }
        schedule(tw, 28);
      } else {
        twCi += 1;
        inp.placeholder = p.slice(0, twCi);
        if (twCi >= p.length) {
          schedule(() => {
            twDel = true;
            tw();
          }, 2100);
          return;
        }
        schedule(tw, 52 + Math.random() * 38);
      }
    }

    schedule(tw, 900);
  }

  function init() {
    const inp = getBannerInput();
    const bar = getAiBar();
    if (!inp || !bar) return;

    bar.hidden = true;

    startTypewriter(inp);

    document.querySelectorAll(SUG_SEL).forEach(wireSuggestion);

    const btn = document.querySelector('[data-hb-ai-submit]');
    btn?.addEventListener('click', (e) => {
      e.preventDefault();
      processBannerSearch();
    });

    inp.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        processBannerSearch();
      }
    });

    document.querySelector('[data-hb-ai-bar-close]')?.addEventListener('click', () => {
      clearAiUi();
    });

       document.addEventListener('hb-ai-search-cleared', () => {
      lastAiQuery = '';
      persistentAiHandles = null;
      persistentAiScores = new Map();
      persistentNoMatch = false;
      lastAiBarMsg = '';
      const b = getAiBar();
      if (b) {
        b.hidden = true;
        b.classList.remove('hb-collection-ai-bar--fallback');
      }
      const inputClear = getBannerInput();
      if (inputClear) inputClear.value = '';
      setAllTabAiState(false);
    });

    document.addEventListener('hb-collection-dom-refreshed', (e) => {
      if (!e.detail?.needAiReapply) return;
      if (persistentAiHandles !== null) {
        reapplyAiIntersection({ scroll: false });
      } else if (lastAiQuery.trim()) {
        applyAiQuery(lastAiQuery, { scroll: false });
      }
    });

        document.addEventListener('hb-quiz-applied', () => {
      persistentAiHandles = null;
      persistentAiScores = new Map();
      persistentNoMatch = false;
      lastAiQuery = '';
      lastAiBarMsg = '';
      const b = getAiBar();
      if (b) {
        b.hidden = true;
        b.classList.remove('hb-collection-ai-bar--fallback');
      }
      const inputClear = getBannerInput();
      if (inputClear) inputClear.value = '';

      setAllTabAiState(false);
    });
  }

  window.HbAiSearch = {
    applyQuery,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
